import React, { Component, Fragment } from 'react';
import { NavLink } from 'react-router-dom';

import { DatePicker } from '@material-ui/pickers';
import TextField from '@material-ui/core/TextField';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

import { booleanConvert, stableSort, getSorting, isNullOrEmpty } from '../Common/helpers';
import EnhancedTableHead from '../Common/TableHead/EnhancedTableHead';
import ModalBox from '../Common/Modals/ModalBox';
import Search from '../Common/Search/Search';

import './style.css';

import { API } from '../../ws/constants';
import moment from 'moment';

class Clients extends Component {
    /* START Constructor */
    constructor(props) {
        super(props);

        this.state = {
            fetchData: null
            , showPageTotal: !isNullOrEmpty(sessionStorage.getItem("orders_showPageTotal")) ? sessionStorage.getItem("orders_showPageTotal") === "true" : true
            , valueFilter: !isNullOrEmpty(sessionStorage.getItem("orders_valueFilter")) ? sessionStorage.getItem("orders_valueFilter") === "true" : false
            , dateFilter: !isNullOrEmpty(sessionStorage.getItem("orders_dateFilter")) ? sessionStorage.getItem("orders_dateFilter") === "true" : false
            , valueFilterStart: !isNullOrEmpty(sessionStorage.getItem("orders_valueFilterStart")) ? sessionStorage.getItem("orders_valueFilterStart") : ""
            , valueFilterEnd: !isNullOrEmpty(sessionStorage.getItem("orders_valueFilterEnd")) ? sessionStorage.getItem("orders_valueFilterEnd") : ""
            , dateFilterStart: !isNullOrEmpty(sessionStorage.getItem("orders_dateFilterStart")) ? sessionStorage.getItem("orders_dateFilterStart") : moment()
            , dateFilterEnd: !isNullOrEmpty(sessionStorage.getItem("orders_dateFilterEnd")) ? sessionStorage.getItem("orders_dateFilterEnd") : moment()
            , openModal: false
            , order: 'desc'
            , orderBy: 'OrderId'
            , page: 0
            , rowsPerPage: 10
            , tableLoading: false
        };
    }

    /* END Constructor */

    /* START React own Functions */

    componentDidMount() {
        this.setState({ tableLoading: true });

        if (sessionStorage.getItem("orders_valueFilter") === "true" || sessionStorage.getItem("orders_dateFilter") === "true") {
            this.getFilteredData();
        } else {
            fetch(API + "getorders")
            .then(response => response.json())
            .then(data => this.setState({ fetchData: data, tableLoading: false }));
        }
    }

    /* END React own Functions */

    /* START Handles */

    handleSearch = (search) => {
        this.setState({ tableLoading: true, page: 0 });
        fetch(API + "searchorders&keyword=" + search)
            .then(response => response.json())
            .then(data => this.setState({ fetchData: data, tableLoading: false }));
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        this.setState({ order, orderBy });
    };

    handleChangeDateFilter = (e, value) => {
        sessionStorage.setItem("orders_dateFilter", value);
        this.setState({ [e.target.id]: value }, this.getFilteredData);
    };

    handleChangeValueFilter = (e, value) => {
        sessionStorage.setItem("orders_valueFilter", value);
        this.setState({ [e.target.id]: value }, this.getFilteredData);
    };

    handleChangeValue = (e) => {
        sessionStorage.setItem("orders_" + e.target.id, e.target.value);
        this.setState({ [e.target.id]: e.target.value }, this.getFilteredData);
    };

    handleDateStartChange = (value) => {
        sessionStorage.setItem("orders_dateFilterStart", value);
        this.setState({ dateFilterStart: value, loading: true }, this.getFilteredData);
    }

    handleDateEndChange = (value) => {
        sessionStorage.setItem("orders_dateFilterEnd", value);
        this.setState({ dateFilterEnd: value, loading: true }, this.getFilteredData);
    }

    handleClearValueStart = () => {
        this.handleChangeValue({ target: { id: "valueFilterStart", value: ""} });
    }

    handleClearValueEnd = () => {
        this.handleChangeValue({ target: { id: "valueFilterEnd", value: ""} });
    }

    handleClearDateStart = () => {
        this.handleDateStartChange(null);
    }

    handleClearDateEnd = () => {
        this.handleDateEndChange(null);
    }

    /* END Handles */

    /* START Component Functions */

    togglePageTotal = () => {
        const { showPageTotal } = this.state;
        sessionStorage.setItem("orders_showPageTotal", !showPageTotal);
        this.setState({ showPageTotal: !showPageTotal });
    }

    openModal = (textObj) => {
        this.setState({ returnTitle: textObj.title, returnText: textObj.text, openModal: true });
    }

    modalCallBack = (result, keepModalOpen) => {
        this.setState({ openModal: keepModalOpen });
    }

    getFilteredData = () => {
        const {
            valueFilter
            , dateFilter
            , valueFilterStart
            , valueFilterEnd
            , dateFilterStart
            , dateFilterEnd
        } = this.state;
        let query = API + "getorders";

        if (valueFilter && valueFilterStart) {
            query += "&valuestart=" + valueFilterStart;
        }
        if (valueFilter && valueFilterEnd) {
            query += "&valueend=" + valueFilterEnd;
        }

        if (dateFilter && dateFilterStart) {
            query += "&datestart=" + moment(dateFilterStart).format('YYYY-MM-DD');
        }

        if (dateFilter && dateFilterEnd) {
            query += "&dateend=" + moment(dateFilterEnd).format('YYYY-MM-DD');
        }

        fetch(query)
        .then(response => response.json())
        .then(data => this.setState({ fetchData: data, tableLoading: false }));
    }

    /* END Component Functions */

    /* START Renders */

    render() {
        const { isAdmin, loginData } = this.props;
        const orders = this.state.fetchData != null ? this.state.fetchData.data.orders : []
            , totals = this.state.fetchData != null ? this.state.fetchData.data.totals : []
            , loadingClass = this.state.tableLoading ? " ajaxLoading" : ""
            , {
                order
                , orderBy
                , rowsPerPage
                , page
                , cheapestOrder
                , expensivestOrder
                , valueFilterStart
                , valueFilterEnd
                , valueFilter
                , dateFilter
                , dateFilterStart
                , dateFilterEnd
                , showPageTotal
            } = this.state
            , headerRows = [
                { id: 'OrderId', active: true, numeric: false, label: 'Nº FR' },
                { id: 'StoreName', active: false, numeric: false, label: 'Loja' },
                { id: 'ClientName', numeric: false, label: 'Cliente' },
                { id: 'StaffName', numeric: false, label: 'Funcionário' },
                { id: 'TotalItems', numeric: false, className: 'smallerHeader', label: 'Items' },
                { id: 'DateCreated', numeric: false, label: 'Data' },
                { id: 'IsCanceled', numeric: false, className: 'midSmallHeader', label: 'Canc.' },
                { id: 'TotalWithVat', numeric: false, label: 'Valor Total' },
                { id: 'Discount', numeric: false, label: 'Desconto' },
                { id: 'actions', notSortable: true, label: 'Ações' },
            ];
        let pageTotalValue = 0;
        let pageTotalDiscount = 0;
        
        return (
            <div id="ordersPage">
                <div>
                    <div className="form row">
                        <Search searchCallback={this.handleSearch}
                            className="col-12 col-md-4" />
                        <div className="col-12 col-md-4">
                            <div className="row">
                                <div className="col-12">
                                    <h2>Filtro por Valor
                                        <span className="float-right activeSwitch">
                                            <FormControlLabel
                                                label="Ativo"
                                                control={
                                                    <Switch
                                                        id="valueFilter"
                                                        checked={!!+valueFilter}
                                                        onChange={this.handleChangeValueFilter}
                                                        color="primary" />
                                                } />
                                        </span>
                                    </h2>
                                </div>
                                <div className="col-12 col-md-6">
                                    <div className="fieldHolder moneyHolder">
                                        <TextField fullWidth={true}
                                            id="valueFilterStart"
                                            type="number"
                                            value={valueFilterStart}
                                            onChange={this.handleChangeValue}
                                            inputProps={{ min: cheapestOrder, max: expensivestOrder }}
                                            label="Início - Valor"
                                            placeholder="Início - Valor"
                                            disabled={!valueFilter}
                                        />
                                        <Tooltip
                                            title={"Remover valor"}
                                            enterDelay={200}>
                                            <button className="actionButton simpleBtn danger clearDiscount" onClick={this.handleClearValueStart}><i className="fa fa-times"></i></button>
                                        </Tooltip>
                                    </div>
                                </div>
                                <div className="col-12 col-md-6">
                                    <div className="fieldHolder moneyHolder">
                                        <TextField fullWidth={true}
                                            id="valueFilterEnd"
                                            type="number"
                                            value={valueFilterEnd}
                                            onChange={this.handleChangeValue}
                                            inputProps={{ min: cheapestOrder, max: expensivestOrder }}
                                            label="Fim - Valor"
                                            placeholder="Fim - Valor"
                                            disabled={!valueFilter}
                                        />
                                        <Tooltip
                                            title={"Remover valor"}
                                            enterDelay={200}>
                                            <button className="actionButton simpleBtn danger clearDiscount" onClick={this.handleClearValueEnd}><i className="fa fa-times"></i></button>
                                        </Tooltip>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-4">
                            <div className="row">
                                <div className="col-12">
                                    <h2>Filtro por data
                                        <span className="float-right activeSwitch">
                                            <FormControlLabel
                                                label="Ativo"
                                                control={
                                                    <Switch
                                                        id="dateFilter"
                                                        checked={!!+dateFilter}
                                                        onChange={this.handleChangeDateFilter}
                                                        color="primary" />
                                                } />
                                        </span>
                                    </h2>
                                </div>
                                <div className="fieldHolder col-12 col-md-6">
                                    <DatePicker
                                        fullWidth={true}
                                        id="dateFilterStart"
                                        label="Inicio"
                                        format="DD/MM/YYYY"
                                        placeholder="Inicio"
                                        value={dateFilterStart}
                                        locale="pt-PT"
                                        maxDate={dateFilterEnd || moment()}
                                        onChange={this.handleDateStartChange}
                                        disabled={!dateFilter}
                                    />
                                    <Tooltip
                                        title={"Remover data"}
                                        enterDelay={200}>
                                        <span><button className="actionButton simpleBtn danger clearDiscount" onClick={this.handleClearDateStart}><i className="fa fa-times"></i></button></span>
                                    </Tooltip>
                                </div>
                                <div className="fieldHolder col-12 col-md-6">
                                    <DatePicker
                                        fullWidth={true}
                                        id="dateFilterEnd"
                                        label="Fim"
                                        format="DD/MM/YYYY"
                                        placeholder="Fim"
                                        value={dateFilterEnd}
                                        locale="pt-PT"
                                        minDate={dateFilterStart || moment("1900-01-01")}
                                        maxDate={moment()}
                                        onChange={this.handleDateEndChange}
                                        disabled={!dateFilter}
                                    />
                                    <Tooltip
                                        title={"Remover data"}
                                        enterDelay={200}>
                                        <span><button className="actionButton simpleBtn danger clearDiscount" onClick={this.handleClearDateEnd}><i className="fa fa-times"></i></button></span>
                                    </Tooltip>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="pageHeader">
                        <h1><i className="fa fa-cash-register"></i> Compras <span className="arrayCount">({orders.length})</span>
                            {(isAdmin || loginData.profile.Cart.ADD) &&
                                <span className="float-right">
                                    <Tooltip
                                        title={"Adicionar Compra"}
                                        enterDelay={200}>
                                        <span><NavLink className="actionButton success" to={"/Cart"}><i className="fa fa-plus"></i></NavLink></span>
                                    </Tooltip>
                                </span>
                            }
                        </h1>
                    </div>
                    <Table className={"responsiveTable customTable" + loadingClass}>
                        <EnhancedTableHead
                            className="tableRow tableHeader"
                            headerRows={headerRows}
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={this.handleRequestSort}
                            rowCount={orders.length}>
                        </EnhancedTableHead>
                        <TableBody>
                            {stableSort(orders, getSorting(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map(_order => {
                                    pageTotalValue += parseFloat(_order.TotalWithVat);
                                    pageTotalDiscount += parseFloat(_order.Discount);
                                    return (
                                        <TableRow key={_order.Id} className="tableRow" ref={"orderId_" + _order.Id}>
                                            <TableCell data-title="Nº FR" className="tableCell">{_order.OrderId}</TableCell >
                                            <TableCell data-title="Loja" className="tableCell"><div className="smallColorDiv" style={{ backgroundColor: _order.StoreColor }}></div> {_order.StoreName} - {_order.StoreShortname}</TableCell >
                                            <TableCell data-title="Cliente" className="tableCell">
                                                <Tooltip
                                                    title={_order.ClientFullName}
                                                    enterDelay={200}>
                                                    <span><NavLink to={"/Clients/" + _order.ClientId}>{_order.ClientFirstName} {_order.ClientLastName}</NavLink></span>
                                                </Tooltip>
                                                {
                                                    _order.ClientGlobalNotes && (isAdmin || loginData.profile.Clients.globalNotes) &&
                                                    <Tooltip
                                                        title={_order.ClientGlobalNotes}
                                                        enterDelay={200}>
                                                        <span><button className="simpleBtn danger globalNotesWarning" onClick={() => this.openModal({ title: "Notas do Cliente", text: _order.ClientGlobalNotes })}><i className="far fa-sticky-note fa-2x"></i></button></span>
                                                    </Tooltip>
                                                }
                                            </TableCell>
                                            <TableCell data-title="Funcionário" className="tableCell">{_order.StaffFirstName} {_order.StaffLastName}</TableCell>
                                            <TableCell data-title="Items" className="tableCell smallerCell">{_order.TotalItems}</TableCell>
                                            <TableCell data-title="Data" className="tableCell">{_order.DateCreated}</TableCell>
                                            <TableCell data-title="Canc." className="tableCell midSmallCell">{booleanConvert(_order.IsCanceled)}</TableCell>
                                            <TableCell data-title="Valor Total" className="tableCell">{parseFloat(_order.TotalWithVat).toFixed(2) + "€"}</TableCell>
                                            <TableCell data-title="Desconto" className="tableCell">{parseFloat(_order.Discount).toFixed(2) + "€"}</TableCell>
                                            <TableCell data-title="Ações" className="tableCell actions" data-row-id={_order.Id}>
                                                {(isAdmin || loginData.profile.Cart.permission === 1) &&
                                                    <Tooltip
                                                        title={"Editar Compra"}
                                                        enterDelay={200}>
                                                        <span><NavLink className="actionButton warning" to={"/Orders/" + _order.Id}><i className="fa fa-pencil-alt"></i></NavLink></span>
                                                    </Tooltip>
                                                }
                                                {loginData.profile.Cart && loginData.profile.Cart.permission === 2 &&
                                                    <Tooltip
                                                        title={"Ver Compra"}
                                                        enterDelay={200}>
                                                        <span><NavLink className="actionButton success" to={"/Orders/" + _order.Id}><i className="fa fa-eye"></i></NavLink></span>
                                                    </Tooltip>
                                                }
                                                {(isAdmin || loginData.profile.Cart.DEL) &&
                                                    <Tooltip
                                                        title={"Eliminar Compra"}
                                                        enterDelay={200}>
                                                        <span><button type="button" className="simpleBtn actionButton danger" onClick={() => this.deleteRow(_order.Id)}><i className="fa fa-times"></i></button></span>
                                                    </Tooltip>
                                                }
                                            </TableCell>
                                        </TableRow>
                                    )
                                })}
                            {(isAdmin || (loginData.profile.Orders && loginData.profile.Orders.viewTotals)) &&
                                <Fragment>
                                    { showPageTotal && 
                                    <TableRow key="999998" className="tableRow totalsRow">
                                        <TableCell className="tableCell" colSpan="5"><h4>Total Página</h4></TableCell>
                                        <TableCell className="tableCell" colSpan="2"></TableCell> 
                                        <TableCell className="tableCell"><p>{parseFloat(pageTotalValue).toFixed(2) + "€"}</p></TableCell>
                                        <TableCell className="tableCell"><p>{parseFloat(pageTotalDiscount).toFixed(2) + "€"}</p></TableCell>
                                        <TableCell className="tableCell actions">
                                                <Tooltip
                                                    title={"Esconder Total de Página"}
                                                    enterDelay={200}>
                                                    <span><button type="button" className="simpleBtn actionButton" onClick={this.togglePageTotal}><i className="fa fa-eye-slash"></i></button></span>
                                                </Tooltip>
                                        </TableCell> 
                                    </TableRow>
                                    }
                                    <TableRow key="999999" className="tableRow totalsRow">
                                        <TableCell className="tableCell" colSpan="5"><h4>Total</h4></TableCell>
                                        <TableCell className="tableCell" colSpan="2"></TableCell> 
                                        <TableCell className="tableCell"><p>{parseFloat(totals.TotalValue).toFixed(2) + "€"}</p></TableCell>
                                        <TableCell className="tableCell"><p>{parseFloat(totals.TotalDiscount).toFixed(2) + "€"}</p></TableCell>
                                        <TableCell className="tableCell actions">
                                                { !showPageTotal && 
                                                <Tooltip
                                                    title={"Mostrar Total de Página"}
                                                    enterDelay={200}>
                                                    <span><button type="button" className="simpleBtn actionButton" onClick={this.togglePageTotal}><i className="fa fa-eye"></i></button></span>
                                                </Tooltip>
                                                }
                                        </TableCell> 
                                    </TableRow>
                                </Fragment>
                            }
                        </TableBody>
                    </Table>
                </div>
                <div className="row">
                    <div className="col-12">
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={orders.length}
                            rowsPerPage={rowsPerPage}
                            labelRowsPerPage="Linhas por página:"
                            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                            page={page}
                            backIconButtonProps={{
                                'aria-label': 'Página anterior',
                            }}
                            nextIconButtonProps={{
                                'aria-label': 'Próxima página',
                            }}
                            onChangePage={this.handleChangePage}
                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                        />
                    </div>
                </div>
                {this.state.openModal && <ModalBox modalCallBack={this.modalCallBack} isActive={this.state.openModal} modalHtml={<div className="col-12"><h2>{this.state.returnTitle}</h2><p>{this.state.returnText}</p></div>} />}
            </div>
        );
    }
}

export default Clients;
